export { default } from './segmentMiniRules'
